<template>
  <div class="breaking-free-element">
    <div class="app-markup-areas">
      <div class="app-toolkit__row row">
        <div class="col-8 col-lg-6 col-md-6 col-xl-5 offset-2 offset-lg-0 offset-md-3" ref="pdfContainer">
          <div
            ref="pdfBody"
            :style="'--bg-image: url(\'' + $store.state.rootUrl + 'build/pix/background.jpg\');'"
            :class="{'pdf-body--printing': $store.state.printToPdfInProgress, 'app-mockup-wrapper': true}"
          >
            <div
              v-if="elements.length === 0"
              :class="{'currently-editing__row': true, 'row': true, 'min-height-override': !$store.state.currentlyEditing.includes(element.identifier)}"
            >
              <div class="col-sm-12">
                <div class="alert alert-info text-center">
                  <p>Füge Bereiche aus dem Werkzeugkasten hinzu, indem du sie auf die Fläche ziehst.</p>
                </div>
              </div>
            </div>
            <vue-draggable-next
              :class="{'drag-area': true, 'ghost-parent-area': true, 'drag-area--highlight-drop-area': $store.state.connectingDrag, 'drag-area--printing': $store.state.printToPdfInProgress}"
              :fallback-tolerance="1"
              :force-fallback="true"
              ghost="ghost"
              :group="{ name: 'areas', put: true, pull: false }"
              handle=".handle"
              item-key="id"
              :list="elements"
              @change="draggableChange($event)"
            >
              <base-loading v-if="loading" />
              <template
                v-for="element in elements"
                :key="element.id"
              >
                <!-- area -->
                <app-markup-area
                  v-if="element.type === 'area'"
                  :element="element"
                  :identifier="element.identifier"
                  :number-of-areas="elements.length"
                  :panel-class="panelClass(element.id, element.disabled)"
                  :parent-id="id"
                  @delete:self="deleteArea($event)"
                >
                  <template
                    v-for="(setting, key) in element.elements"
                    :key="'dropdown for' + setting + 'with key' + key"
                  >
                    <app-input-dropdown
                      v-if="typeof setting.settings !== 'undefined' && setting.settings.preview"
                      v-model="element.selection[key]"
                      :area="element"
                      :element="setting"
                      :identifier="'option' + key + 'in' + element.identifier"
                      :true-element="element"
                      @update:model-value="saveElements()"
                    />
                  </template>

                </app-markup-area>
              </template>
            </vue-draggable-next>
          </div>
        </div>
        <div class="app-toolkit__mobil col-lg-6 col-xl-7">
          <app-toolkit
            :configured-areas="modifiedAreas"
            @end-connecting-drag="tryingToConnect = false"
            @start-connecting-drag="tryingToConnect = true"
            @add-element-manually="addElementManually($event)"
          >
            <app-action-links
              v-show="elements.length > 0"
              @generate-pdf="generatePDF()"
              @send-link="sendLink()"
              @send-contact-form="sendContactForm()"
              @copy-shortcode="copyShortcode()"
            />
            <hr
              v-if="elements.length > 0"
            >
          </app-toolkit >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {VueDraggableNext} from 'vue-draggable-next';
import AppToolkit from '@/components/AppToolkit.vue';
import lang from '@/helpers/lang'
import AppMarkupArea from '@/components/AppMarkupArea.vue';
import BaseLoading from '@/components/BaseLoading.vue';
import handleAlerts from '@/helpers/HandleAlerts';
import AppInputDropdown from '@/components/AppInputDropdown.vue';
import jsPDF from 'jspdf';
import AppActionLinks from '@/components/AppActionLinks.vue';
import BasePanel from '@/components/BasePanel.vue';

export default {
  /**
   * Komponente für das Markup der Areas, das tatsächliche "Mockup-Tool"
   * @displayName AppMarkupAreas
   */
  name: 'AppMarkupAreas',
  components: {
    BasePanel,
    AppActionLinks,
    AppInputDropdown,
    AppMarkupArea,
    AppToolkit,
    VueDraggableNext,
    BaseLoading,
  },
  props: {
    /**
     * Das konfigurierte Datenobjekt für das Feld das dargestellt werden soll
     */
    element: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      tryingToConnect: false,
      configuredAreas: JSON.parse(window.mockuptoolSettings.config),
      elements: [],
      loading: false,
      id: 1,
      file: null,
    }
  },
  computed: {
    creatingPdf() {
      return this.$store.state.printToPdfInProgress
    },
    modifiedAreas() {
      Object.keys(this.configuredAreas).forEach(areaName => {
        let area = this.configuredAreas[areaName];
        area.selection = {}; // adding an object to store settings in
      })

      return this.configuredAreas
    }
  },
  mounted() {
    this.loadSavedData();
  },
  methods: {
    async copyShortcode() {
      let shortcode = await this.trackConfig();

      try {
        if (!shortcode.error) {
          navigator.clipboard.writeText(shortcode.url);
        }
        else if (typeof shortcode !== 'undefined' && typeof shortcode.message !== 'undefined') {
          alert(shortcode.message);
        }
        else  {
          alert('Es ist ein Fehler aufgetreten');
          if ($store.state.debug) {
            console.log(e);
          }
        }
      }
      catch (e) {
        alert('Es ist ein Fehler aufgetreten');
        if ($store.state.debug) {
          console.log(e);
        }
      }
    },
    async trackConfig() {
      const apiUrl = this.$store.state.rootUrl.split('themes/q2e-2021/')[0] + 'index.php?page=MDL_x1mockuptoolconfig.&action=generateShortCodeLink';
      // eslint-disable-next-line no-undef

      let result = await $.post(apiUrl, {
        'config': JSON.stringify(this.elements),
        'page_path_id': window.mockuptoolSettings.pageId,
        'config_source': 1
      });

      return result
    },
    generatePDF() {
      // fixing the height of the pdf container to prevent page jumping
      let height = this.$refs.pdfContainer.clientHeight;
      this.$refs.pdfContainer.style.height = height + 'px';

      this.$store.commit('creatingPdf', true);
      this.trackConfig();

      let doc = new jsPDF('p','pt','a4',true),
          margins = [20, 20, 20, 60]; //Page margins [top, right, bottom, left]

      doc.html(this.$refs.pdfBody, {
        'margin': margins,
        'x': 0,
        'y': 0,
        'windowWidth': 555,
        'width': 555,
      }).then(() => {
        // adding a title image
        let pageCount,
            title = new Image(),
            background = new Image(),
            pricing = new Image(),
            width = doc.internal.pageSize.getWidth(),
            height = doc.internal.pageSize.getHeight(),
            i = 1;

        title.src = this.$store.state.rootUrl + 'src/vue/public/title.png';
        doc.addPage(); // adding an empty page
        doc.addImage(title, 'png', 0, 0, width, height); // adding an image (to the current new empty last page)

        background.src = this.$store.state.rootUrl + 'src/vue/public/background.png';
        doc.addPage(); // adding an empty page
        doc.addImage(background, 'png', 0, 0, width, height); // adding an image (to the current new empty last page)

        // adding a list of selected areas to the title page
        doc.setTextColor(47, 149, 144); // mint
        doc.setFontSize(16); // in pt
        doc.setFont('Helvetica', 'bold');
        doc.text(['Deine Gestaltungsbereiche im Überblick'], 67, 87, {lineHeightFactor: 2.2});

        // adding a list of selected areas to the title page
        let yPosition = 130,
          xPosition = 60,
          addPerLine = 25,
          addPerSmallLine = 15;
        doc.setFont('Helvetica', '');

        this.elements.forEach((area, index) => {
          let text = parseInt(index + 1) + '. ' + area.lang.title,
              settings = [],
              settingsText = '';

          doc.setTextColor(0, 0, 0); // black
          doc.setFontSize(11); // in pt
          doc.text(text, xPosition, yPosition, {lineHeightFactor: 2.2});

          Object.keys(area.selection).forEach(key => {
            settings.push(area.elements[key].settings.options[area.selection[key]]);
          })

          if (settings.length > 0) {
            yPosition = yPosition + addPerSmallLine;
          }

          settings.forEach((setting, index) => {
            if (index === 0) {
              settingsText += ' (';
            }
            if (index > 0) {
              settingsText += ', '
            }

            settingsText += setting;

            if (index === settings.length-1) {
              settingsText += ')'
            }
          })

          if (settingsText.length > 0) {
            doc.setTextColor(90, 90, 90); // gray
            doc.setFontSize(9.5); // in pt
            doc.text(settingsText, xPosition + 10, yPosition, {lineHeightFactor: 1.6});
          }
          yPosition = yPosition + addPerLine;
        })

        pageCount = doc.internal.getNumberOfPages(); // finding out the now final number of pages
        doc.movePage(pageCount - 1, 1); // moving the second to last page to the start of the document

        // adding the price list
        pricing.src = this.$store.state.rootUrl + 'src/vue/public/pricing.png';
        doc.addPage(); // adding an empty page
        doc.addImage(pricing, 'png', 0, 0, width, height); // adding an image (to the current new empty last page)

        // saving and wrapping up
        doc.save('q2e_wowsite-planer.pdf');
        this.$store.commit('creatingPdf', false);

        // returning to dynamic height for the pdf container
        this.$refs.pdfContainer.style.height = 'auto';
        this.showAlert('Dein WOWsite-Pdf wurde erfolgreich generiert und im Downloads Ordner gespeichert.', 'success');
      });
    },
    getLang: lang.get,
    showAlert: handleAlerts.show,
    deleteArea(id) {
      let elementsCopy = JSON.parse(JSON.stringify(this.elements.filter(i => i.id !== id)));

      // saving in session
      sessionStorage.setItem('q2e_frontend_mockup_areas_of_page_' + this.id, JSON.stringify(elementsCopy));
      this.elements = elementsCopy;
    },
    panelClass(id) {
      let string = 'app-elements-area-wireframe__panel';

      if (this.$store.state.showWireframes || this.$store.state.currentlyEditing.includes(id)) {
        string += ' app-elements-area-wireframe__panel--wireframe-visible';
      }

      if (this.$store.state.printToPdfInProgress) {
        string += ' app-elements-area-wireframe__panel--printing'
      }

      return string;
    },
    draggableChange(event) {
      if (Object.hasOwn(event, 'moved')) {
        this.reorderElements();
      } else if (Object.hasOwn(event, 'added')) {
        this.addElementByDrag(event);
      }
    },
    addElementByDrag(event) {
      this.loading = true;

      this.addElement(this.elements[event.added.newIndex].id, event.added.newIndex)
    },
    addElementManually(event) {
      this.loading = true;
      this.elements.push(event);

      this.addElement(event.id, this.elements.length - 1)
    },
    addElement(id, index) {
      let sessionData = [];

      // copying the existing elements, to evade reactivity while doing the transformation
      let elementsCopy = JSON.parse(JSON.stringify(this.elements));

      // modifying the id of the new area to be unique by adding the current time
      elementsCopy[index].id = id + Date.now();

      sessionData = JSON.stringify(elementsCopy); // stringifying to store in session
      this.elements = elementsCopy; // redeclaring elements

      // saving in session
      sessionStorage.setItem('q2e_frontend_mockup_areas_of_page_' + this.id, sessionData);

      // on success remove loading
      this.loading = false;
    },
    reorderElements() {
      this.saveElements();
    },
    saveElements() {
      this.loading = true;
      // saving the new order in session
      sessionStorage.setItem('q2e_frontend_mockup_areas_of_page_' + this.id, JSON.stringify(this.elements));

      // on success remove loading
      this.loading = false;
    },
    loadSavedData() {
      this.loading = true;
      let config = '',
          searchParams = new URLSearchParams(window.location.search);

      if (searchParams.has('mockup')) {
        config = window.mockuptoolSettings.configFromShortcode;

        if (config !== '') {
          this.elements = JSON.parse(config);
          this.saveElements();
        }
        else {
          alert('Der Mockup-Shortcode ist entweder unvollständig oder abgelaufen.');
        }
      }
      else {
        this.elements = JSON.parse(sessionStorage.getItem('q2e_frontend_mockup_areas_of_page_' + this.id)) || [];
      }
      this.loading = false;
    },
    sendLink() {
      // eslint-disable-next-line
      $('.js-insert_code_here').val(JSON.stringify(this.elements));
      // eslint-disable-next-line
      $('.js-focus_email').focus();
    },
    sendContactForm() {
      // eslint-disable-next-line
      $('.js-insert_code_here1005').val(JSON.stringify(this.elements));
    }
  }
}
</script>

<style lang="less">
.app-markup-areas {
    position: relative;
    transition: margin 0.5s ease 0s,
                width 0.5s ease 0s;
  margin-top: 40px;
}

.pdf-text {
  font-size: 11px !important;
}

.pdf-body--printing {
  &:before {
    content: 'Deine Gestaltungsbereiche';
    color: #2f9590;
    font-weight: bold;
    font-size: 12.6pt;
    display: inline-block;
    margin: 48px 0 20px 0;
  }

  /*background-color: #fff;
  background-image: var(--bg-image);
  background-size: 100% auto;
  background-repeat: repeat-y;
  background-position: center;*/
}

.app-mockup-wrapper {
  @media (min-width: 992px) {
    margin-right: 50px;
  }
}
</style>